import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LOGIN_PAGES } from '../enum-login-pages';
import { LoginService } from '../../../services/login-service/login.service';
import Swal from 'sweetalert2';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { MixpanelService } from '../../../services/mixpanel-service/mixpanel.service';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
})
export class SignUpComponent implements OnInit {
  @Output() nextStep = new EventEmitter<number>();
  @Output() currentEmail = new EventEmitter<string>();
  @Output() userLocked = new EventEmitter<boolean>();
  @Input() email = '';
  @Input() applicationType = '';

  loading = false;

  CountryCodeOptions = [
    { label: '+1', value: '+1' },
    { label: '+52', value: '+52' },
  ];

  frmLogin = new FormGroup({
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(
        '[a-zA-Z0-9._-]{3,}@[a-zA-Z0-9.-]{3,}[.][a-zA-Z]{2,4}'
      ),
    ]),
    first_name: new FormControl('', [
      Validators.required,
      Validators.maxLength(25),
      Validators.pattern('[a-zA-Z -]{3,}'),
    ]),
    last_name: new FormControl('', [
      Validators.required,
      Validators.maxLength(50),
      Validators.pattern('[a-zA-Z -]{3,}'),
    ]),
    company_name: new FormControl('', [
      Validators.required,
      Validators.maxLength(50),
    ]),
    country_code: new FormControl('+1'),
    phone_no: new FormControl('', {
      validators: [Validators.required, Validators.pattern('[0-9]{10}')],
    }),
  });

  constructor(
    private loginService: LoginService,
    private dialogRef: DynamicDialogRef,
    private mixpanelService: MixpanelService
  ) {}

  ngOnInit(): void {
    this.frmLogin.controls['email'].setValue(this.email);
  }

  validatePhone() {
    return !(
      this.frmLogin.value.phone_no === '' && this.frmLogin.value.phone_no !== ''
    );
  }

  signUp() {
    const userData: any = this.frmLogin.value;
    if (!userData) {
      return;
    }
    this.loading = true;
    let contact_number = '';
    if (
      this.frmLogin.value.country_code !== '' &&
      this.frmLogin.value.phone_no !== ''
    ) {
      contact_number =
        this.frmLogin.value.country_code + ' ' + this.frmLogin.value.phone_no;
    }
    userData.contact_number = contact_number;
    userData.application_type = this.applicationType;
    this.mixpanelService.init(userData.email);
    this.mixpanelService.track(userData.email, 'user_signup');
    this.loginService.signupUser(userData).subscribe(
      () => {
        this.loading = false;
        Swal.fire({
          position: 'top-end',
          text: 'Signup details submitted successfully!',
          timer: 1000,
          icon: 'success',
          showConfirmButton: false,
        }).then(() => {
          this.mixpanelService.track(userData.email, 'SIGN_UP_SUCCESS');
          this.nextStep.emit(LOGIN_PAGES.SIGN_UP_SCREEN_SUCCESS);
        });
      },
      ({ error }) => {
        this.loading = false;
        this.dialogRef.close();
        this.mixpanelService.track(
          userData.email,
          'SIGN_UP_ERROR :' + error?.message
        );
        Swal.fire({
          position: 'top-end',
          text: error?.message,
          icon: 'error',
          timer: 5000,
          showConfirmButton: false,
        });
      }
    );
  }
}
